import * as React from "react";
const SvgUnorderedList = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "64 64 896 896", focusable: "false", "data-icon": "unordered-list", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...props }, /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  strokeWidth: 70,
  stroke: "currentColor",
  strokeLinecap: "round"
}, x1: 365.493, y1: 267.682, x2: 845.877, y2: 267.682 }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  strokeWidth: 70,
  stroke: "currentColor",
  strokeLinecap: "round"
}, x1: 365.493, y1: 498.361, x2: 845.877, y2: 498.361 }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  strokeWidth: 70,
  stroke: "currentColor",
  strokeLinecap: "round"
}, x1: 365.493, y1: 729.039, x2: 845.877, y2: 729.039 }), /* @__PURE__ */ React.createElement("ellipse", { style: {
  fill: "currentColor"
}, cx: 205.785, cy: 268.264, rx: 65.275, ry: 65.275 }), /* @__PURE__ */ React.createElement("ellipse", { style: {
  fill: "currentColor"
}, cx: 205.785, cy: 498.787, rx: 65.275, ry: 65.275 }), /* @__PURE__ */ React.createElement("ellipse", { style: {
  fill: "currentColor"
}, cx: 205.785, cy: 729.311, rx: 65.275, ry: 65.275 }));
export default SvgUnorderedList;
